/**
 * Validação centralizada de tamanho de inputs
 * Limites aplicados nos componentes e no banco de dados
 */

export const INPUT_LIMITS: Record<string, number> = {
  PROJECT_NAME: 100,
  PROJECT_DESCRIPTION: 2000,
  TASK_NAME: 200,
  TASK_DESCRIPTION: 5000,
  RISK_TITLE: 200,
  RISK_DESCRIPTION: 2000,
  CHANGE_TITLE: 200,
  CHANGE_DESCRIPTION: 2000,
  COST_CATEGORY: 100,
  COST_DESCRIPTION: 1000,
  FULL_NAME: 100,
  EMAIL: 254,
  WIKI_TITLE: 200,
  WIKI_CONTENT: 50000,
  GENERIC_SHORT: 200,
  GENERIC_LONG: 5000,
};

/**
 * Valida se o valor está dentro do limite de tamanho
 * @param {string} value
 * @param {number} maxLength
 * @returns {boolean}
 */
export function validateInputLength(value: string | null | undefined, maxLength: number): boolean {
  if (!value) return true;
  return String(value).length <= maxLength;
}

/**
 * Trunca o valor para o limite de tamanho
 * @param {string} value
 * @param {number} maxLength
 * @returns {string}
 */
export function truncateInput(value: string | null | undefined, maxLength: number): string | null | undefined {
  if (!value || typeof value !== 'string') return value;
  return value.slice(0, maxLength);
}
